import { render } from "./AppAllModals.vue?vue&type=template&id=1368a490"
import script from "./AppAllModals.vue?vue&type=script&lang=js"
export * from "./AppAllModals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__